import { createStyles, makeStyles, Theme } from '@material-ui/core'

type ExplosionProps = {
  viewPort: cadex.ModelPrs_ViewPort
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      width: '70px',
      height: '160px',
      display: 'flex',
      justifyContent: 'center',
      overflow: 'hidden',
      position: 'relative',
      borderRadius: '5%',
      paddingTop: '13px',

      '&:hover': {
        background: theme.palette.background.default,
      },

      '& > input': {
        transform: 'rotate(90deg)',
        height: '130px',
      },
    },
  })
)

export const Explosion = ({ viewPort }: ExplosionProps) => {
  const cn = useStyles()

  const handleExplosion = (value: string) => {
    viewPort.exploder.value = parseFloat(value) / 1000
  }

  return (
    <div className={cn.root}>
      <input
        type="range"
        defaultValue="0"
        min="0"
        max="300"
        onChange={(ev) => handleExplosion(ev.currentTarget.value)}
      />
    </div>
  )
}
